import React, { Fragment, useContext, useEffect } from "react";
import { useDarkMode } from "../../utils/themes/useDarkMode";
import { GlobalStyles, darkTheme, lightTheme } from "../../utils/themes/theme";
import { ThemeProvider } from "styled-components";
import "../../styles/layout/DashboardLayout.css";
import HeaderNav from "./HeaderNav";
import ConfirmLogoutModal from "./ConfirmLogoutModal";
// import SessionEndModal from "./SessionExpired";
import ActionContext from "../../context/ActionContext";
import { useDispatch } from "react-redux";
// import RootState from "../../redux/types";
import LoadingConfigPage from "../../fragments/LoadingConfigPage";
import { getConfig } from "../../redux/auth";
import { encrypt2 } from "../../utils/encrypt";
// import { getMerchantInfo } from "../../redux/overview";
// import NoPageFound from "../../fragments/NoPageFound";

interface MyComponentProps {
  children?: React.ReactNode;
  dontIncludeHeader?: boolean;
}
const bankboxLogo = (
  <svg
    className="img"
    width="65"
    height="14"
    viewBox="0 0 65 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_542_21830)">
      <path
        d="M18.8671 5.39994C18.8748 5.40914 18.8899 5.43793 18.9135 5.45594C20.0368 6.32033 20.2755 7.59313 19.4995 8.78153C18.8428 9.78714 17.9023 10.3359 16.6871 10.3575C15.8567 10.3723 15.0259 10.3699 14.1959 10.3567C13.8887 10.3519 13.6399 10.4187 13.3975 10.6255C12.9475 11.0099 12.4095 11.2347 11.7607 11.3835C11.8063 11.2183 11.8303 11.0935 11.8751 10.9767C12.2983 9.87233 12.7259 8.76954 13.1495 7.66473C13.2075 7.51354 13.2495 7.35634 13.2991 7.20194C13.2687 7.18434 13.2379 7.16634 13.2076 7.14874C13.1396 7.23234 13.0583 7.30833 13.0055 7.40033C12.6835 7.95993 12.3751 8.52674 12.0479 9.08314C11.8379 9.44034 11.6171 9.79274 11.3783 10.1315C10.4583 11.4367 9.17675 12.1499 7.61595 12.3947C7.43395 12.4231 7.25195 12.4515 7.06915 12.4743C7.02595 12.4795 6.97995 12.4619 6.86435 12.4435C7.67195 11.1415 8.49755 9.89073 9.30435 8.62833C10.1015 7.38073 10.9003 6.13434 11.6987 4.88754C11.6655 4.86193 11.6323 4.83634 11.5987 4.81114C11.4971 4.93154 11.3895 5.04753 11.2951 5.17353C10.5475 6.16954 9.80875 7.17194 9.05475 8.16314C8.16915 9.32714 7.23075 10.4455 6.12195 11.4091C5.08835 12.3071 3.95115 13.0191 2.60555 13.3531C1.82115 13.5479 0.711149 13.5611 0.0771484 13.3791C0.0991484 13.1727 0.277948 13.0831 0.405148 12.9707C1.13195 12.3303 1.87155 11.7043 2.59955 11.0655C5.50395 8.51833 8.29595 5.85634 10.8355 2.93954C11.3099 2.39474 11.7751 1.84074 12.2215 1.27314C12.4139 1.02874 12.6379 0.931935 12.9343 0.935135C14.4711 0.953535 16.0084 0.964335 17.5452 0.987935C17.8347 0.992335 18.1308 1.01394 18.4111 1.08034C20.0972 1.48034 20.6875 3.18794 19.6152 4.55714C19.3892 4.84594 19.1283 5.10714 18.8667 5.39954L18.8671 5.39994ZM14.1347 8.98953C14.2479 9.02553 14.3047 9.05954 14.3611 9.05954C15.0199 9.05553 15.6791 9.05873 16.3371 9.03473C16.7992 9.01793 17.1435 8.76393 17.4023 8.39713C17.6388 8.06193 17.7431 7.68274 17.736 7.27074C17.7251 6.66754 17.3444 6.17313 16.7528 6.13474C16.0375 6.08834 15.3167 6.12354 14.5343 6.12354C14.3991 7.09394 14.2671 8.03954 14.1343 8.98913L14.1347 8.98953ZM14.7435 4.76714C15.4727 4.76714 16.1647 4.82474 16.8424 4.75074C17.5028 4.67874 17.9779 3.89274 17.8976 3.17754C17.8284 2.55914 17.4223 2.26154 16.6327 2.25874C16.2336 2.25754 15.834 2.26114 15.4352 2.27474C15.1108 2.28594 15.0687 2.32634 15.0207 2.64354C14.9519 3.09834 14.8891 3.55434 14.8283 4.01033C14.7967 4.24833 14.7743 4.48754 14.7435 4.76714Z"
        fill="#014345"
      />
      <path
        d="M28.2296 3.22813L27.3176 9.73293H25.2628L25.4332 8.48053C24.874 9.39253 24.1444 9.85453 23.2568 9.85453C22.0288 9.85453 20.4604 8.99133 20.8008 6.49893C21.1412 3.95773 23.0256 3.10693 24.2904 3.10693C25.032 3.10693 25.6156 3.39853 26.0656 3.97013L26.1748 3.22853H28.2296V3.22813ZM25.652 6.92413L25.8708 5.40413C25.5548 4.63813 25.1412 4.24893 24.6428 4.24893C24.2172 4.24893 23.8404 4.45573 23.5 4.88093C23.1716 5.29413 22.9528 5.84133 22.8676 6.51013C22.7824 7.13013 22.8192 7.65293 22.9892 8.07853C23.1716 8.50413 23.4512 8.71093 23.8524 8.71093C24.4724 8.71093 25.0684 8.11533 25.652 6.92373V6.92413Z"
        fill="#014345"
      />
      <path
        d="M35.5975 5.58685L35.0139 9.73285H32.9591L33.5307 5.65965C33.5791 5.01524 33.5915 4.23725 32.9107 4.23725C32.3027 4.23725 31.7071 4.85725 31.1355 6.08525L30.6247 9.73285H28.5699L29.4819 3.22805H31.5367L31.3663 4.45605C31.9379 3.55645 32.6795 3.10645 33.5911 3.10645C35.0135 3.10645 35.7919 4.11565 35.5971 5.58685H35.5975Z"
        fill="#014345"
      />
      <path
        d="M40.8256 5.76923L42.8072 9.73283H40.4848L39.342 7.07003L38.6124 7.72643L38.3328 9.73243H36.266L37.5668 0.492432H39.6216L38.8556 5.97603L41.944 3.22803H43.5976L40.8256 5.76923Z"
        fill="#014345"
      />
      <path
        d="M50.6368 7.2648C50.5272 7.97 50.1992 8.5536 49.652 9.028C49.1048 9.502 48.436 9.7332 47.6704 9.7332H43.7312L44.9592 1.052H48.5216C50.1632 1.052 51.0628 1.964 50.868 3.3256C50.7584 4.1036 50.3332 4.7116 49.5792 5.1372C50.3572 5.4896 50.7708 6.28 50.6368 7.2648ZM49.3116 7.2648C49.5184 5.9272 48.558 5.5992 48.0348 5.5992H45.6276L45.1532 8.9308H47.5728C48.0836 8.9308 49.1412 8.578 49.3116 7.2652V7.2648ZM45.7372 4.7968H47.9744C48.4728 4.7968 49.3848 4.5416 49.5552 3.3256C49.7256 2.0856 48.8864 1.8544 48.3636 1.8544H46.1508L45.7376 4.7968H45.7372Z"
        fill="#014345"
      />
      <path
        d="M52.254 8.89413C51.7068 8.24973 51.5124 7.44733 51.646 6.47453C51.7796 5.51413 52.2052 4.71133 52.9228 4.06733C53.6524 3.42293 54.4912 3.10693 55.4396 3.10693C56.388 3.10693 57.1296 3.42293 57.6644 4.06733C58.2116 4.71173 58.406 5.51413 58.2724 6.47453C58.1384 7.44733 57.7132 8.24973 56.9956 8.89413C56.2784 9.53853 55.4392 9.85453 54.4908 9.85453C53.5424 9.85453 52.8008 9.53853 52.2536 8.89413H52.254ZM56.1324 8.32253C56.5944 7.79973 56.874 7.19173 56.9836 6.47453C57.0808 5.76933 56.9712 5.16133 56.6432 4.65093C56.3272 4.12813 55.8892 3.87293 55.33 3.87293C54.7708 3.87293 54.26 4.12813 53.798 4.65093C53.336 5.16173 53.0564 5.76933 52.9468 6.47453C52.8496 7.19173 52.9588 7.79973 53.2752 8.32253C53.6036 8.83333 54.0412 9.08853 54.6004 9.08853C55.1596 9.08853 55.6704 8.83333 56.1324 8.32253Z"
        fill="#014345"
      />
      <path
        d="M60.7768 6.57163L58.8924 3.22803H60.4488L61.7864 5.57443L63.9508 3.22803H64.9236L62.1516 6.18243L64.0848 9.73283H62.5408L61.1548 7.19163L58.8692 9.73283H57.9088L60.7784 6.57163H60.7768Z"
        fill="#014345"
      />
    </g>
    <defs>
      <clipPath id="clip0_542_21830">
        <rect
          width="64.8456"
          height="13.0152"
          fill="white"
          transform="translate(0.0771484 0.492432)"
        />
      </clipPath>
    </defs>
  </svg>
);

const DashboardLayout: React.FC<MyComponentProps> = ({
  children,
  dontIncludeHeader,
}) => {
  const [theme, toggleTheme] = useDarkMode(localStorage.getItem("theme"));
  const themeMode = theme === "light" ? lightTheme : darkTheme;
  const actionCtx = useContext(ActionContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length < 1) {
      getConfigFunc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getConfigFunc = async () => {
    // const urlToUse = window?.location.href?.split("?domain=")[1];
    // const obj = {
    //   url: urlToUse
    // }
    const data = await dispatch(getConfig({} as any) as any);
    // console.log(data);

    if (data?.payload?.status === "success") {
      const obj = data?.payload?.data?.data;
      // console.log(obj);
      const encryptedVal = await encrypt2(obj?.appkey ?? "");
      localStorage.setItem("kasali", encryptedVal);
      actionCtx?.setConfigDetails(obj);
      actionCtx?.setNoConfigFound(false);
    } else {
      actionCtx?.setNoConfigFound(true);
      // localStorage?.setItem("theme", "light");
    }
  };

  return (
    <Fragment>
      <ThemeProvider theme={themeMode}>
        <GlobalStyles />
        {actionCtx?.noConfigFound ? (
          <>
            <LoadingConfigPage />
          </>
        ) : (
          <div className="dashboard-layout-index-wrap">
            {/* header wrap start */}
            {!dontIncludeHeader && (
              <div className="header-wrap-index-box">
                <div className="size-wrap-global">
                  <HeaderNav theme={theme} toggleTheme={toggleTheme} />
                </div>
              </div>
            )}
            {/* header wrap end */}
            {/* header wrap start */}
            <div className="main-wrap-index-box">
              <div
                className={`size-wrap-global ${
                  dontIncludeHeader && "size-wrap-global-two"
                }`}
              >
                {children}
                {/* <div className="child"></div> */}
              </div>
            </div>
            {/* header wrap end */}
            {/* header wrap start */}
            <div className="footer-wrap-index-box">
              <div className="size-wrap-global">
                <div className="power-by-box border-theme card-bg">
                  <p className="text grey-white-color">Powered by</p>
                  <div className="img-wrap-box">
                    <figure className="img-box">{bankboxLogo}</figure>
                  </div>
                </div>
              </div>
            </div>
            {/* header wrap end */}
            {/* </div> */}
          </div>
        )}

        {!actionCtx?.sessionExpire && <ConfirmLogoutModal />}
      </ThemeProvider>
    </Fragment>
  );
};

export default DashboardLayout;
